import {
  Divider,
  LinearProgress,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  Typography,
} from '@mui/material';
import { Pipeline } from '../../../../store/data/types';
import { Link } from 'react-router-dom';
import CreatePipelineEntry from '../../../CreatePipelineEntry/CreatePipelineEntry';
import useGetPipelinesByEmail from '../../../../shared/hooks/useGetPipelinesByEmail';
import { createIconFromName } from '../../../../util/iconUtil';
import ErrorTypography from '../../../../shared/ErrorTypography/ErrorTypography';
import { Trans } from 'react-i18next';
import { useAppSelector } from '../../../../store/hooks';

const PipelineList = (): JSX.Element => {
  const { data, error, isLoading } = useGetPipelinesByEmail();
  const loggedIn = useAppSelector(state => state.usertoken.authenticated)

  let listItems: JSX.Element[];
  if (error) {
    if (loggedIn) {
      listItems = [
        <ListItem key={0}>
          <ListItemText>
            <ErrorTypography message={'Error fetching pipelines'} />
          </ListItemText>
        </ListItem>,
      ];
    }
    else {
      listItems = [
        <ListItem key={0}>
          <ListItemText>
            <ErrorTypography message={'Not logged in!'} />
          </ListItemText>
        </ListItem>,
      ];
    }

  } else if (!isLoading && data) {
    listItems = (data as Pipeline[]).map((pipeline, i) => (
      <ListItemButton component={Link} key={i} to={`/pipeline/${pipeline.pid}`}>
        <ListItemIcon>{createIconFromName(pipeline.pipeline.icon)}</ListItemIcon>
        <ListItemText primary={pipeline.pipeline.name} />
      </ListItemButton>
    ));
    if (listItems.length === 0) {
      listItems = [
        <ListItem key={0}>
          <ListItemText>
            <Typography>
              <Trans>No pipelines found</Trans>
            </Typography>
          </ListItemText>
        </ListItem>,
      ];
    }
  } else {
    listItems = [
      <ListItem key={0}>
        <ListItemText>
          <LinearProgress />
        </ListItemText>
      </ListItem>,
    ];
  }

  return (
    <>
      <List>
        <ListSubheader>
          <ListItemText>
            <Trans>Pipelines</Trans>
          </ListItemText>
        </ListSubheader>
        <div className='pipelineList-wrapper'>
          {listItems}
        </div>
      </List>
      {listItems.length > 0 && <Divider />}
      <List>
      <div className='test5'>
        <CreatePipelineEntry />
      </div>
      </List>
    </>
  );
};

export default PipelineList;
